/*
 * Purpose of this file is to allow to easily redirect to
 * the audience page of a specific podcast, without putting
 * extra logic in a component.
 */

const audienceShowRoutes = [
  {
    path: 'analytics',
    children: [
      {
        path: '/',
        name: 'audience-show',
        props: true,
        beforeEnter: async (to, from, next) => {
          next({name: 'audience'})
        }
      }
    ]
  }
]
export default audienceShowRoutes
